<script setup lang="ts">
import { computed, ref } from 'vue';
import { useQuasar } from 'quasar';
import { useRoute } from 'vue-router';
import CourseGradeBook from '@/components/Reports/CourseGradeBook.vue';
import Enrollment from '@/components/Reports/CourseEnrollment.vue';
import { useSchoolStore } from '@/stores/school';

const schoolStore = useSchoolStore();
const tab = ref<string>('Class Roster');
const route = useRoute();
const currentRating = computed(() => schoolStore.course?.ratings.find(
    (rating) => rating.acronym.localeCompare(route.params.ratingAcronym as string, 'en', { sensitivity: 'base' }) === 0,
));

const $q = useQuasar();
</script>
<template>
    <div
        v-if="schoolStore.school !== null && schoolStore.course !== null && currentRating !== undefined"
        class="fsum-report"
        :class="{ 'q-mx-md': $q.screen.lt.sm, 'q-mx-xl': !$q.screen.lt.sm }"
    >
        <div class="fsum-report-header text-center q-my-md">
            <h1 class="fsum-report-title q-my-none">
                {{ schoolStore.course?.certificate.title }}
            </h1>
            <h2 class="fsum-report-subtitle q-my-none">
                {{ currentRating?.acronym }}: {{ currentRating?.title }}
            </h2>
            <h6
                v-if="schoolStore.school.name"
                class="school-name print-only q-my-none"
            >
                {{ schoolStore.school.name }}
            </h6>
        </div>
        <div class="fsum-tabs">
            <q-tabs
                v-model="tab"
                class="q-mb-md"
                indicator-color="fsum-red3"
                breakpoint="0"
                align="left"
                no-caps
                inline-label
            >
                <q-tab
                    name="Class Roster"
                    label="Class Roster"
                    icon="sym_o_list_alt"
                />
                <q-tab
                    name="Grade Book"
                    label="Grade Book"
                    icon="sym_o_class"
                />
            </q-tabs>
            <q-tab-panels
                v-model="tab"
                animated
                class="tab-pages"
            >
                <q-tab-panel name="Class Roster">
                    <div class="row">
                        <Enrollment
                            :current-school="schoolStore.school"
                            :current-course="schoolStore.course"
                            :current-rating-uuid="currentRating.uuid"
                        />
                    </div>
                </q-tab-panel>
                <q-tab-panel name="Grade Book">
                    <div class="row">
                        <CourseGradeBook
                            :current-school="schoolStore.school"
                            :current-course="schoolStore.course"
                            :current-rating-uuid="currentRating.uuid"
                        />
                    </div>
                </q-tab-panel>
            </q-tab-panels>
        </div>
    </div>
    <q-banner
        v-else
        class="text-white bg-red"
    >
        You must select a course.
    </q-banner>
</template>
<style scoped>
h1.fsum-report-title {
    font-size: 48px;
    font-weight: 700;
    color: var(--fsum-black);
    line-height: normal;
}

h2.fsum-report-subtitle {
    font-size: 20px;
    font-weight: 700;
    color: var(--fsum-gray3);
}
:deep(.fsum-tabs .tab-pages) {
    margin: 0;
}
</style>
